import { makeStyles } from "@mui/styles";

const ModalWrapperStyles = makeStyles((theme: any) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  modalContainer: {
    borderRadius: 10,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: 25
  }
}));
export default ModalWrapperStyles;
